<template>
    <span>
      <v-chip v-for="(v,k,i) in per_cur" key="`per_cur-${k}`">
          {{v}} {{k}} 
      </v-chip>
    </span>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: ['orders'],
  data: () => ({
    dummy: false,
  }),
  beforeMount: async function() {},
  mounted() {
  },

  computed: {
    ...mapState(['event_products', 'event_sales_channels', 'event_orders']),
    per_cur() {
        // map orders into currency, amount
        let cas = this.orders.map(o => { return { currency: o.currency, amount: o.amount} })
        console.log("cas", cas)

        let result = {}
        this.orders.forEach(o => {
            result[o.currency] = 0;
        })
        this.orders.forEach(o => {
            result[o.currency] += parseFloat(o.amount);
        })
        console.log("casres", result)
        return result
    }
  },
  methods: {
  },
};
</script>

<style scoped>
.order_item {
  border: 1px solid black;
}

.orderBanner {
  background: blue;
  color: white;
  display: block;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  padding: 0.25em;
  margin-bottom: 0.25em;
}
</style>
